import { i18n } from "../../helpers/i18n";
import type { Jurisdiction } from "../../contract";

export const operatorInfoTranslation = i18n({ key: "I18N.BETSLIP.OPERATOR_REGULATION" });

export const OPERATOR_INFO_JURISDICTIONS: Jurisdiction[] = ["ITALY", "SPAIN", "INTERNATIONAL"];
